import { createFileRoute } from '@tanstack/react-router';
import { PagesHistory } from '@/components/customisation/history-pages';
import { SiteHistory } from '@/components/customisation/history-site';
import { useStudioTenant } from '@/routes/_app/admin/customisation';

export const Route = createFileRoute('/_app/admin/customisation/history')({ component: Page });

/** Publishing history: site revisions (compare, load into draft, roll back) and page revisions. */
function Page() {
  const tenant = useStudioTenant();
  return (
    <div className="mx-auto grid max-w-[1100px] gap-10 px-4 py-8 sm:px-6 lg:px-8">
      <div>
        <h2 className="text-xl font-semibold tracking-tight">History</h2>
        <p className="text-muted-foreground mt-1 text-sm">
          Everything that was published, rolled back or kept as a snapshot. Rolling back changes
          what customers see; loading a revision into the draft doesn’t.
        </p>
      </div>
      <SiteHistory tenant={tenant} />
      <PagesHistory tenant={tenant} />
    </div>
  );
}
